import { useState } from 'react';
import { useParams } from 'react-router-dom';
import CreateTemplate from '..';
import { saveLaboratory } from '../../../../../../services/api/laboratory';
import { updatePreProcessedDocument } from '../../../../../../services/api/preProcessedDocuments';
import { createProjectTemplate } from '../../../../../../services/api/projectTemplates';
import { FORMSATTR, TABLEATTR } from './formItems';

const CreatePreLaboratoryTemplate = () => {
  const { preprocessId, id } = useParams();
  const { fileName } = useParams();
  const [templateId, setTemplateId] = useState(null);

  const newTemplate = async (regions, formState, fileName) => {
    const regionIndex = regions.findIndex((reg) => reg.data === 'provider');
    const region = regions[regionIndex];
    regions.splice(regionIndex, 1);
    const laboratory = {
      name: formState.supplier_id.value,
      phone_number: formState.phone_number.value,
      email: formState.email.value,
    };

    const newLaboratory = await saveLaboratory(laboratory);
    const newTemplate = {
      name: formState.templateName.value,
      supplier: formState.supplier_id.value,
      model: 'laboratory',
      image: fileName.replace('pdf', 'png'),
      labId: newLaboratory.data.id,
      searchableRegion: {
        value: '',
        region: region,
      },
      regions: regions,
      pid: parseInt(id, 10),
    };

    const createdTemplate = await createProjectTemplate(newTemplate);
    setTemplateId(createdTemplate.data.id);

    const updatepp = {
      template: createdTemplate.data.id,
      supplier: createdTemplate.data.supplier,
    };
    await updatePreProcessedDocument(preprocessId, updatepp);

    return 'templateCreated';
  };

  const nextButton = () => {
    return `/app/project/${id}/quality/ocr/readDocument/prelaboratory/${templateId}/${preprocessId}/${fileName}`;
  };

  return (
    <CreateTemplate
      tableAttr={TABLEATTR}
      formsAttr={FORMSATTR}
      closeForm={newTemplate}
      customFinishButton={nextButton}
      model="laboratory"
    />
  );
};

export default CreatePreLaboratoryTemplate;
